export enum DashboardListType {
  Draft,
  Removed,
  Submitted,
}
